var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui segment" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.fundings, function(funding, index) {
        return _c("div", { key: index }, [
          _c("div", { staticClass: "ui segment" }, [
            _c("div", { staticClass: "ui top left attached label" }, [
              _vm._v(_vm._s(funding.type))
            ]),
            _vm._v(" "),
            funding.name != null
              ? _c("div", [_vm._v(_vm._s(_vm.getI18n(funding.name, "en")))])
              : _vm._e(),
            _vm._v(" "),
            funding.acronym != null
              ? _c("div", [_vm._v(_vm._s(funding.acronym))])
              : _vm._e()
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "balance scale icon" }),
      _vm._v(" Fundings :\n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }